// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Zf","link":"Zch"};